var fixedPosition = null

$(document).ready(function(){

   if ($(".template-collection").length>0) {
       //Travar Caixa; 
       travarCaixa();
   } 

  
   var $elementTems = $('#caixa-termos .text');

    if ($elementTems.length) { // Verifica se o elemento existe

        console.log(getCookie("caixaTermos") )
        if (getCookie("caixaTermos") === "true") {
          $("#caixa-termos").addClass("inactive");
        }else{
          console.log("aqui");
          $("#caixa-termos").removeClass("inactive");
        }
      
        // Função para verificar se o scroll está no final
        function isScrolledToEnd() {
            return $elementTems[0].scrollHeight - $elementTems.scrollTop() <= $elementTems.outerHeight();
        }

        // Verifica se tem scroll
        if ($elementTems[0].scrollHeight <= $elementTems.outerHeight()) {
            $(".btnConfirmar").removeClass("inactivebtn");
        } else {
            // Adiciona um evento de scroll para verificar quando o scroll chega ao final
            $elementTems.on('scroll', function() {
                if (isScrolledToEnd()) {
                    $(".btnConfirmar").removeClass("inactivebtn");
                }
            });
        }
    }
  
  /*
    if($('#Filter-Disponibilidade-1').length > 0){
     if (!$('#Filter-Disponibilidade-1').is(':checked')) {
      $("#Filter-Disponibilidade-1").parent().find(".facets-checkbox__marker").trigger("click");
     }
    }
*/ 
  
    $(".header__nav a[href='/collections/esquenta-black-friday'], .unstyled-link[href='/collections/esquenta-black-friday']").addClass("orangeLink");
    //$(".header__nav a[href='/collections/outlet-1'], .unstyled-link[href='/collections/outlet-1']").addClass("orangeLink");
    $(".header__nav .header-menu-trigger:contains('ATÉ 70% OFF')").addClass("orangeLink");
    $(".header-mobile__menus .header-mobile__menu-main span:contains('ATÉ 70% OFF')").addClass("orangeLink");

  
  /*
    var h4Element = $("h4.facets__details-title").filter(function() {
        return $(this).text().trim() === "Cor";
    });

    if (h4Element.length > 0) {
        console.log("achoe");
        $(h4Element).closest("details").css("display","none");
    }


    var corEl = $("legend.product-form__group-name").filter(function() {
        return $(this).text().trim() === "Cor";
    });

    if (corEl.length > 0) {
        $(corEl).closest("fieldset").css("display","none");
    }
*/
    mobileOnlySlider();

  swiper = [];
if($('.todoComponenteCarrossel').length > 0){
  $('.todoComponenteCarrossel .swiper').each(function(i, el){
    swiper[i] = new Swiper(el, {
      slidesPerView: 2,
      spaceBetween: 32, // Espaço entre os slides
       navigation: {
        nextEl: $(el).find('.swiper-button-next')[0],
        prevEl: $(el).find('.swiper-button-prev')[0],
      },
      loop: true, // Não usar loop para evitar problemas de alinhamento
      freeMode: false, // Manter o modo livre desativado para evitar deslizamento "solto"
      centeredSlides: false, // Desativa centragem dos slides
      watchOverflow: true, // Impede o loop quando não há slides suficientes
      speed: 300, // Ajusta a velocidade da transição para mais controle
    pagination: {
        el: ".swiper-pagination",
      clickable: true,
      },
      grabCursor: true, // Adiciona cursor de "pegada" para melhor UX
      breakpoints: {
        758: {
          slidesPerView: 4,
          spaceBetween: 32, // Ajusta o espaço para 4 colunas
        },
        540: {
          slidesPerView: 3,
          spaceBetween: 32, // Ajusta o espaço para 3 colunas
        }
      }
    });
  });
}


  
});

$(window).scroll(function () {
   if ($(".template-collection").length>0) {
      travarCaixa();
   } 
})



function travarCaixa() {
    // Verifica se a largura da janela é menor que 1200px e define o elemento de cabeçalho
    var headerElement = $(window).width() < 1200 ? '#header-mobile-menu' : '#section-header';

  if($(window).width() < 1200 ){
    $("body").addClass("mobsHeader");
  }else{
    $("body").removeClass("mobsHeader");
  }

    // Pega a posição do rodapé do elemento header definido
    var sectionHeaderBottom = $(headerElement).offset().top + $(headerElement).outerHeight();
  
    // Pega a posição do topo do elemento FacetFiltersForm
    var facetFiltersFormTop = $('#FacetFiltersForm').offset().top;
    
    // Verifica se a base do cabeçalho encostou no topo de #FacetFiltersForm
    if (sectionHeaderBottom >= facetFiltersFormTop) {
        // Armazena a posição de fixação uma única vez
        if (fixedPosition === null) {
            fixedPosition = facetFiltersFormTop;
        }

        $('body').addClass("bodyFiltroFixa");
        
        if($('body').hasClass("mobsHeader")){
          alturaVencer = $('#FacetFiltersForm').outerHeight() +  $(headerElement).outerHeight() ; 
           $("#ProductGridContainer").css("margin-top",alturaVencer+"px");
        }else{
           $("#ProductGridContainer").css("margin-top","0");
        }

        $('#FacetFiltersForm').addClass("faixaFizedFiltro");

        var sectionHeaderHeight = $(headerElement).outerHeight();
        $('#FacetFiltersForm').css("top", sectionHeaderHeight + "px");
    }  
  
    // Remover a classe ao rolar para cima, além da posição fixada
    if (fixedPosition !== null && $(window).scrollTop() < fixedPosition - 150) {
        $('body').removeClass("bodyFiltroFixa");
        $("#ProductGridContainer").css("margin-top","0");
        $('#FacetFiltersForm').removeClass("faixaFizedFiltro");
        $('#FacetFiltersForm').css("top", "0px");
        fixedPosition = null; // Reseta a posição fixa ao voltar
    }
}

$(document).on("click","#caixa-termos .btnConfirmar",function(){
  if($(this).hasClass("inactivebtn")){
    alert("Leia os termos e condições antes de prosseguir");
  }else{
    $("#caixa-termos").addClass("inactive");
    document.cookie = "caixaTermos=true; max-age=" + 30*24*60*60 + "; path=/";
  }
});

// Função para obter o valor de um cookie
function getCookie(name) {
  let cookieArr = document.cookie.split(";");

  for(let i = 0; i < cookieArr.length; i++) {
    let cookiePair = cookieArr[i].split("=");

    // Remover espaço no nome do cookie e verificar se é o que queremos
    if(name == cookiePair[0].trim()) {
      return decodeURIComponent(cookiePair[1]);
    }
  }
  return null;
}



$(window).resize(function() {
    mobileOnlySlider();
});


$(document).on('click',".header-mobile__burger-wrraper",function(){
  $("body").toggleClass("menuAtivo");
})

/*$(".open_filters").on("click",function(){
    if($('#Filter-Disponibilidade-1').length > 0){
     if (!$('#Filter-Disponibilidade-1').is(':checked')) {
      $("#Filter-Disponibilidade-1").parent().find(".facets-checkbox__marker").trigger("click");
     }
    }
});*/

function  mobileOnlySlider () {
    if (window.innerWidth <= 768) {
        if (!$('.section-template--22950840992056__collection_grid_ibG4Nz-padding ul.collection-grid__list').hasClass('slick-initialized')) {
            carregaSlickMobs();
        }

    } else {
        if ($('.section-template--22950840992056__collection_grid_ibG4Nz-padding ul.collection-grid__list').hasClass('slick-initialized')) {
            $('.section-template--22950840992056__collection_grid_ibG4Nz-padding ul.collection-grid__list').slick('unslick');
        }
    }
}

function carregaSlickMobs(){
    $('.section-template--22950840992056__collection_grid_ibG4Nz-padding ul.collection-grid__list').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        variableWidth: true,
        arrows: false,
        dots:true,
        adaptiveHeight: true,
        autoplay: false,
        swipeToSlide: true,
        autoplaySpeed: 1800,
        slide: "li",
        infinite:true
    });
} 


/*Modo escuro*/
window.addEventListener('DOMContentLoaded', () => {
    const esquema = localStorage.getItem('_color_schema');
    if (esquema === 'dark') {
      // atualiza o valor no localStorage
      localStorage.setItem('_color_schema', 'light');
      // (opcional) aplica classe no <body>
      document.body.setAttribute('data-scheme', 'light');      
    }
});